// extracted by mini-css-extract-plugin
export default {"dragFileElement":"guVOCcJzUzvN7BrSog_9","dragContainer":"v3tsBNw7P9YW2rAty3JA","dragContainerActive":"GKxdnX_ZpQBXjX1v9XNB"};